import { BrowserRouter, useSearchParams } from "react-router-dom";
import ProjectLayout from "@common/general/ProjectLayout";
import { useEffect } from "react";
import { useProjectDataStore } from "@state/projectDataStore";
import PayloadLivePreview from "@utils/PayloadLivePreview";
import { useStore } from "@state/store";
import { parseTSV } from "@data/parseTSV";
import { useFavoritesStore } from "@state/favouritesStore";
import { tempData } from "@data/temp_data.js";
import LightsBroadcaster from "@common/components/LightsController/LightsBroadcaster";

function App() {
  const syncState = useStore((s) => s.syncState);
  const { clearFavorites } = useFavoritesStore((state) => state);

  useEffect(() => {
    window.addEventListener("contextmenu", (e) => e.preventDefault());
    const fetchData = async () => {
      try {
        let response;
        try {
          response = await fetch(
            // "https://docs.google.com/spreadsheets/d/e/2PACX-1vTC9JzEZXOFC-5lB8f7GJ3D17_oKOHj6r7x7-0-ez1BABilmvSXfIFZALkad9N29441puZ9Nt6CFVxg/pub?gid=0&single=true&output=tsv",
            "https://docs.google.com/spreadsheets/d/e/2PACX-1vQFU5o1j0cMcILJAT2nlV6LYMFDg9Gpt8SsZL9SvgA7vAq0Q3QhGurz5YkTYTWoaw/pub?gid=61035114&single=true&output=tsv",
          );

          if (!response.ok) {
            throw new Error(`Server responded with status ${response.status}`);
          }
        } catch (fetchError) {
          console.error("Fetch error:", fetchError);

          const cachedData = localStorage.getItem("availabilityData");
          if (cachedData) {
            const parsedCache = JSON.parse(cachedData);
            if (Array.isArray(parsedCache) && parsedCache.length > 0) {
              // console.log("SET CACHED DATA")

              syncState({
                availabilityData: parsedCache,
              });

              return;
            }
          }

          syncState({
            availabilityData: tempData,
          });
          return;
        }

        const data = await response.text();
        const parsed = parseTSV(data);

        const transformed = parsed.map((item) => {
          return {
            ...item,
            floor: parseInt(item.floor),
            price: parseInt(item.price),
            beds: parseInt(item.beds),
            planType: `${item.floor}.${item.plotNumber}`,
          };
        });

        localStorage.setItem("availabilityData", JSON.stringify(transformed));

        syncState({
          availabilityData: transformed,
        });
      } catch (error) {
        console.error("Unexpected error:", error);

        syncState({
          availabilityData: tempData,
        });
      }
    };

    fetchData();
    clearFavorites();
  }, []);

  return (
    <BrowserRouter>
      <ProjectWrapper />
    </BrowserRouter>
  );
}

export default App;

function ProjectWrapper() {
  const { livePreview, setLocalState } = useProjectDataStore((s) => ({
    livePreview: s.livePreview,
    setLocalState: s.setLocalState,
  }));

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const openNavParam = searchParams.get("livePreview");
    if (openNavParam !== null) {
      setLocalState({ livePreview: true });
    }
  }, [searchParams]);
  const isLondon = import.meta.env.VITE_ROOT_BUILD === "london";
  return (
    <>
      <ProjectLayout />
      {livePreview && <PayloadLivePreview />}
      {isLondon && <LightsBroadcaster />}
    </>
  );
}
